import { render, staticRenderFns } from "./TheCheckboxes.vue?vue&type=template&id=97bcc434"
import script from "./TheCheckboxes.vue?vue&type=script&lang=js"
export * from "./TheCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./TheCheckboxes.vue?vue&type=style&index=0&id=97bcc434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports